enum SalesDivisionCodeEnum {
	showroom = 'SHOWROOM', // Previous "satellite"
	marketHall = 'MARKET_HALL', // Previous "satellite"
	selfServe = 'SELF_SERVE', // Previous "self_serve"
	warehouse = 'WAREHOUSE' // Previous "full_serve" - Contact coworker
}

export default SalesDivisionCodeEnum;
